import {Pipe, PipeTransform} from '@angular/core';
import {ClientZoekMethode} from '../client/clientnummer-selector/clientnummer';

@Pipe({
    name: 'zahPrestatieZoekmethodeIcon',
    standalone: false
})
export class PrestatieZoekmethodeIconPipe implements PipeTransform {

  transform(zoekmethode: ClientZoekMethode): string {
    return zoekmethode === ClientZoekMethode.QR_CODE ? 'qr_code' : 'person_search';
  }
}
